import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const app = {
  state: {
    sidebar: {
      opened: localStorage.getItem('sidebarStatus') || 1,
      withoutAnimation: false
    },
    loadMenus: false,
    menus: [],
    language: localStorage.getItem('language') || 'zh'
  },
  mutations: {
    TOGGLE_SIDEBAR(state) {
      if (state.sidebar.opened) {
        localStorage.setItem('sidebarStatus', '1')
      } else {
        localStorage.setItem('sidebarStatus', '0')
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR(state, withoutAnimation) {
      localStorage.setItem('sidebarStatus', '1')
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    SET_MENUS(state, menus) {
      state.menus.splice(0);
      state.menus.push(...menus);
      state.loadMenus = true;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      localStorage.setItem('language', language)
    }
  },
  actions: {
    ToggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    SetMenus({ commit }, { menus }) {
      commit('SET_MENUS', menus)
    },
    SetLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    }
  }
}
export default app

